/*global module*/
var Buffer = require('buffer').Buffer;

module.exports = function toString(obj) {
  if (typeof obj === 'string')
    return obj;
  if (typeof obj === 'number' || Buffer.isBuffer(obj))
    return obj.toString();
  return JSON.stringify(obj);
};



//////////////////
// WEBPACK FOOTER
// ./~/jws/lib/tostring.js
// module id = 186
// module chunks = 42